import { render, staticRenderFns } from "./RoundButton.vue?vue&type=template&id=85b9e01e&scoped=true&lang=pug&"
import script from "./RoundButton.vue?vue&type=script&lang=js&"
export * from "./RoundButton.vue?vue&type=script&lang=js&"
import style0 from "./RoundButton.vue?vue&type=style&index=0&id=85b9e01e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b9e01e",
  null
  
)

export default component.exports